import React, { useEffect, useState, useRef } from "react";
import "../portraitList/portraitList.css";
import "./landscapeList.css";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import SectionHeader from "../sectionHeader/sectionHeader";
import Global, { THBTD } from "../../global";
import { Link } from "react-router-dom";
import Anchor from "../Link/anchor";
import { favourited, favourites, truncate } from "../javascript/function";
import { UserStore } from "../store/store";
import LazyImg from "../lazy/lazy";
import Icon from "../icon/icon";
import { BORDER, VCMS } from "../../global";

const LandscapeList = (props) => {
  const mounted = useRef(false);
  const init = { playlist: [] };
  const y_init = { items: [] };
  const [llstelem, setLLSTElem] = useState([]);
  const [llstelemItem, setLLSTItem] = useState([]);
  const [llstplaylist, setLLSTPlaylist] = useState(
    Global.VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  /* eslint-disable no-unused-vars */
  const [error, SetError] = useState(false);
  const [elemllstdisplay, setLLSTElemDisplay] = useState(true);
  const [desc, setDesc] = useState(false);
  /* eslint-disable no-unused-vars */
  const [news, setNews] = useState(false);
  /* eslint-disable no-unused-vars */
  const [viewllstAll, setViewllstAll] = useState("");
  const [viewllstLink, setviewllstLink] = useState("");

  const currentUser = UserStore.useState((s) => s.user);
  useEffect(() => {
    mounted.current = true;
    const LLSTElemDetail = async () => {
      /* eslint-disable no-unused-vars */

      if (mounted.current) {
        setLLSTElem(props.tabbed ? props.tabid : props.information);
        setLLSTElemDisplay(
          props.tabbed
            ? props.tabid.devices[0].itemVisibility
            : props.information.devices[0].itemVisibility
        );
        setLLSTItem(props.tabbed ? props.tabid.items : props.information.items);
        if (!props.tabbed) {
          if (
            props.information.playlistId !== null &&
            props.information.playlistId !== ""
          ) {
            LLSTplaylistDetail(
              props.information.playlistId,
              props.information.devices[0].itemSize
            );
          }
          props.information.displayNameVisibility === "On Hover" ||
          props.information.displayNameVisibility === "Show Always" ||
          props.information.displayNameVisibility === "Show Header Only"
            ? setDesc(true)
            : setDesc(false);
          props.information.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.information.viewAllVisibility === true &&
          props.information.viewAllText !== null
            ? setViewllstAll(props.information.viewAllText)
            : setViewllstAll("");
          if (
            props.information.viewAllVisibility === true &&
            props.information.viewAllPage !== null
          ) {
            const link =
              props.information.viewAllPage.pageType === "externalPage"
                ? props.information.viewAllPage.externalPage
                : props.information.viewAllPage.pageType === "internalPage"
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.internalPage
                : props.information.viewAllPage.urlName !== ""
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.urlName
                : "/" +
                  props.match.params.AppId +
                  "/page/" +
                  props.information.viewAllPage._id;
            setviewllstLink(link);
          }
          isLoading(false);
        } else {
          if (
            props.tabid.playlistId !== null &&
            props.tabid.playlistId !== ""
          ) {
            LLSTplaylistDetail(
              props.tabid.playlistId,
              props.tabid.devices[0].itemSize
            );
          }
          props.tabid.displayNameVisibility === "On Hover" ||
          props.tabid.displayNameVisibility === "Show Always" ||
          props.tabid.displayNameVisibility === "Show Header Only"
            ? setDesc(true)
            : setDesc(false);
          props.tabid.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.tabid.viewAllVisibility === true &&
          props.tabid.viewAllText !== null
            ? setViewllstAll(props.tabid.viewAllText)
            : setViewllstAll("");
          if (
            props.tabid.viewAllVisibility === true &&
            props.tabid.viewAllPage !== null
          ) {
            const link =
              props.tabid.viewAllPage.pageType === "externalPage"
                ? props.tabid.viewAllPage.externalPage
                : props.tabid.viewAllPage.pageType === "internalPage"
                ? props.tabid.viewAllPage.internalPage
                : "/" +
                  props.match.params.AppId +
                  "/" +
                  props.tabid.viewAllPage.pageType +
                  "/" +
                  props.tabid.viewAllPage._id;
            setviewllstLink(link);
          }
        }
        isLoading(false);
      }

      /* eslint-disable no-unused-vars */
    };

    const LLSTplaylistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */
      if (VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setLLSTPlaylist(result.data);
              isLoading(false);
            }
          },
          (error) => {
            isLoading(false);
          }
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setLLSTPlaylist(result.data);
              isLoading(false);
            }
          },
          (error) => {
            isLoading(false);
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };

    LLSTElemDetail();

    return () => {
      mounted.current = false;
    };
  }, [props.match.params.AppId, props.information, props.tabid, props.tabbed]);

  if (elemllstdisplay && !error && !loading) {
    return (
      <div>
        <SectionHeader
          title={llstelem.displayName}
          linkTitle={viewllstAll}
          link={viewllstLink}
          header={props.header}
        ></SectionHeader>
        <div
          className={THBTD + " landscapeList"}
          style={{ paddingBottom: props.tabbed ? "20px" : "" }}
        >
          <div className="container-fluid ">
            {llstelemItem !== null
              ? llstelemItem.map((item, index) =>
                  item.itemid.devices[0].itemVisibility ? (
                    <div className="list-item" key={index}>
                      <Anchor
                        className={
                          BORDER
                            ? "slide-one slide-two"
                            : "slide-one slide-two no-border"
                        }
                        to={
                          item.itemid.pageType === "externalPage"
                            ? item.itemid.externalPage
                            : item.itemid.pageType === "internalPage"
                            ? item.itemid.internalPage
                            : item.itemid.pageType === "videoPage"
                            ? props.match.params.AppId +
                              "/" +
                              item.itemid.pageType +
                              "/" +
                              item.itemid.videoId
                            : item.itemid.urlName !== ""
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              item.itemid.urlName
                            : item.itemid.pageType + "/" + item.itemid._id
                        }
                      >
                        <div
                          className={
                            BORDER ? "slide-image" : "slide-image no-border"
                          }
                        >
                          <LazyImg
                            orient={"landscape"}
                            src={
                              item.itemid.landscapeThumbnail
                                ? getAWSUrl() +
                                  item.itemid.landscapeThumbnail.imagekey
                                : ""
                            }
                            alt=""
                          />
                        </div>

                        {Global.THBTD === "BIM" ? (
                          <div
                            className={
                              desc && news
                                ? "ms-exclusive-movie-content onshow"
                                : desc && !news
                                ? "ms-exclusive-movie-content onhover"
                                : "ms-exclusive-movie-content onhide"
                            }
                          >
                            <div>
                              <h4>
                                {" "}
                                {item.itemid.displayName
                                  ? truncate(
                                      item.itemid.displayName,
                                      Global.YOUHEADCHAR
                                    )
                                  : ""}{" "}
                              </h4>
                            </div>
                            <p>
                              {item.itemid.description
                                ? truncate(
                                    item.itemid.description,
                                    Global.YOUPARACHAR
                                  )
                                : ""}
                            </p>
                          </div>
                        ) : Global.THBTD === "BIMWR" ? (
                          <div
                            className={
                              desc && news
                                ? "ms-exclusive-movie-content onshow"
                                : desc && !news
                                ? "ms-exclusive-movie-content onhover"
                                : "ms-exclusive-movie-content onhide"
                            }
                          >
                            <div>
                              <h4>
                                {" "}
                                {truncate(
                                  item.itemid.displayName,
                                  Global.YOUHEADCHAR
                                )}{" "}
                              </h4>
                              <p>
                                {truncate(
                                  item.itemid.description,
                                  Global.YOUPARACHAR
                                )}
                              </p>
                            </div>

                            <div className="ms-exclusive-rating">
                              <span className="play_button_icon">
                                {/*  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                  >
                                    <path
                                      className="cls-1"
                                      d="M561.983,1176.56a0.347,0.347,0,0,0-.284-0.25l-3.72-.57-1.664-3.54a0.348,0.348,0,0,0-.63,0l-1.664,3.54-3.719.57a0.344,0.344,0,0,0-.284.25,0.365,0.365,0,0,0,.089.37l2.691,2.75-0.635,3.89a0.373,0.373,0,0,0,.14.36,0.32,0.32,0,0,0,.207.07,0.315,0.315,0,0,0,.163-0.04l3.327-1.84,3.327,1.84a0.355,0.355,0,0,0,.371-0.03,0.372,0.372,0,0,0,.139-0.36l-0.635-3.89,2.692-2.75A0.365,0.365,0,0,0,561.983,1176.56Z"
                                      transform="translate(-550 -1172)"
                                    ></path>
                                  </svg> */}
                                <i className="fa fa-play"></i>
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={
                              desc && news
                                ? "slide-content showed"
                                : desc && !news
                                ? "slide-content"
                                : "slide-content hidden"
                            }
                          >
                            <h2>
                              {truncate(
                                item.itemid.displayName,
                                Global.HEADCHAR
                              )}
                              {Global.FAVOURITES ? (
                                <span
                                  className="span"
                                  onClick={(event) => {
                                    favourites(event, item.itemid, "page");
                                  }}
                                >
                                  {" "}
                                  <i
                                    className={
                                      favourited(
                                        item.itemid._id,
                                        currentUser.FAVOURITES
                                      )
                                        ? "ri-check-fill"
                                        : "ri-add-line"
                                    }
                                  ></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </h2>
                            <div>
                              <span className="tag">{item.itemid.rating}</span>
                              <span className="tag"></span>
                            </div>
                            <p>
                              {truncate(
                                item.itemid.description,
                                Global.PARACHAR
                              )}
                            </p>
                          </div>
                        )}
                      </Anchor>
                    </div>
                  ) : (
                    <div
                      key={index}
                      className="none"
                      style={{ display: "none" }}
                    ></div>
                  )
                )
              : ""}

            {llstelem.playlistId !== null && llstelem.playlistId !== undefined
              ? VCMS === "YouTube" && llstplaylist.items !== undefined
                ? llstplaylist.items.map((item, index) => (
                    <div className="list-item" key={index}>
                      <Link
                        className={
                          BORDER
                            ? "slide-one slide-two"
                            : "slide-one slide-two no-border"
                        }
                        to={
                          "/" +
                          props.match.params.AppId +
                          "/videoPage/" +
                          item.contentDetails.videoId
                        }
                      >
                        {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                        <div
                          className={
                            BORDER ? "slide-image" : "slide-image no-border"
                          }
                        >
                          <LazyImg
                            orient={"landscape"}
                            src={
                              "https://img.youtube.com/vi/" +
                              item.contentDetails.videoId +
                              "/mqdefault.jpg"
                            }
                            alt=""
                          />
                        </div>
                        {Global.THBTD === "BIM" ? (
                          <div
                            className={
                              desc && news
                                ? "ms-exclusive-movie-content onshow"
                                : desc && !news
                                ? "ms-exclusive-movie-content onhover"
                                : "ms-exclusive-movie-content onhide"
                            }
                          >
                            <div>
                              <h4>
                                {" "}
                                {item.snippet.title
                                  ? truncate(
                                      item.snippet.title,
                                      Global.YOUHEADCHAR
                                    )
                                  : ""}{" "}
                              </h4>
                            </div>
                            <p>
                              {item.snippet.description
                                ? truncate(
                                    item.snippet.description,
                                    Global.YOUPARACHAR
                                  )
                                : ""}
                            </p>
                          </div>
                        ) : Global.THBTD === "BIMWR" ? (
                          <div
                            className={
                              desc && news
                                ? "ms-exclusive-movie-content onshow"
                                : desc && !news
                                ? "ms-exclusive-movie-content onhover"
                                : "ms-exclusive-movie-content onhide"
                            }
                          >
                            <div>
                              <h4>
                                {" "}
                                {truncate(
                                  item.snippet.title,
                                  Global.YOUHEADCHAR
                                )}{" "}
                              </h4>
                              <p>
                                {truncate(
                                  item.snippet.description,
                                  Global.YOUPARACHAR
                                )}
                              </p>
                            </div>

                            <div className="ms-exclusive-rating">
                              <span className="play_button_icon">
                                {/*  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                  >
                                    <path
                                      className="cls-1"
                                      d="M561.983,1176.56a0.347,0.347,0,0,0-.284-0.25l-3.72-.57-1.664-3.54a0.348,0.348,0,0,0-.63,0l-1.664,3.54-3.719.57a0.344,0.344,0,0,0-.284.25,0.365,0.365,0,0,0,.089.37l2.691,2.75-0.635,3.89a0.373,0.373,0,0,0,.14.36,0.32,0.32,0,0,0,.207.07,0.315,0.315,0,0,0,.163-0.04l3.327-1.84,3.327,1.84a0.355,0.355,0,0,0,.371-0.03,0.372,0.372,0,0,0,.139-0.36l-0.635-3.89,2.692-2.75A0.365,0.365,0,0,0,561.983,1176.56Z"
                                      transform="translate(-550 -1172)"
                                    ></path>
                                  </svg> */}
                                <i className="fa fa-play"></i>
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={
                              desc && news
                                ? "slide-content showed"
                                : desc && !news
                                ? "slide-content"
                                : "slide-content hidden"
                            }
                          >
                            <h2>
                              {truncate(item.snippet.title, Global.HEADCHAR)}
                              {Global.FAVOURITES ? (
                                <span
                                  className="span"
                                  onClick={(event) => {
                                    favourites(event, item, "video");
                                  }}
                                >
                                  {" "}
                                  <i
                                    className={
                                      favourited(
                                        item.contentDetails.videoId,
                                        currentUser.FAVOURITES
                                      )
                                        ? "ri-check-fill"
                                        : "ri-add-line"
                                    }
                                  ></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </h2>
                            <div>
                              <span className="tag">{""}</span>
                              <span className="tag">{""}</span>
                            </div>
                            <p>
                              {truncate(
                                item.snippet.description,
                                Global.PARACHAR
                              )}
                            </p>
                          </div>
                        )}
                      </Link>
                    </div>
                  ))
                : llstplaylist.playlist.map((item, index) => (
                    <div className="list-item" key={index}>
                      <Link
                        className={
                          BORDER
                            ? "slide-one slide-two"
                            : "slide-one slide-two no-border"
                        }
                        to={
                          "/" +
                          props.match.params.AppId +
                          "/videoPage/" +
                          item.mediaid
                        }
                      >
                        {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                        <div
                          className={
                            BORDER ? "slide-image" : "slide-image no-border"
                          }
                        >
                          <LazyImg
                            orient={"landscape"}
                            src={item.images[0].src}
                            alt=""
                          />
                        </div>
                        {Global.THBTD === "BIM" ? (
                          <div
                            className={
                              desc && news
                                ? "ms-exclusive-movie-content onshow"
                                : desc && !news
                                ? "ms-exclusive-movie-content onhover"
                                : "ms-exclusive-movie-content onhide"
                            }
                          >
                            <div>
                              <h4>
                                {" "}
                                {item.title
                                  ? truncate(item.title, Global.YOUHEADCHAR)
                                  : ""}{" "}
                              </h4>
                            </div>
                            <p>
                              {item.ShortDescription
                                ? truncate(
                                    item.ShortDescription,
                                    Global.YOUPARACHAR
                                  )
                                : ""}
                            </p>
                          </div>
                        ) : Global.THBTD === "BIMWR" ? (
                          <div
                            className={
                              desc && news
                                ? "ms-exclusive-movie-content onshow"
                                : desc && !news
                                ? "ms-exclusive-movie-content onhover"
                                : "ms-exclusive-movie-content onhide"
                            }
                          >
                            <div>
                              <h4>
                                {" "}
                                {truncate(item.title, Global.YOUHEADCHAR)}{" "}
                              </h4>
                              <p>
                                {truncate(
                                  item.ShortDescription,
                                  Global.YOUPARACHAR
                                )}
                              </p>
                            </div>

                            <div className="ms-exclusive-rating">
                              <span className="play_button_icon">
                                {/*  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                  >
                                    <path
                                      className="cls-1"
                                      d="M561.983,1176.56a0.347,0.347,0,0,0-.284-0.25l-3.72-.57-1.664-3.54a0.348,0.348,0,0,0-.63,0l-1.664,3.54-3.719.57a0.344,0.344,0,0,0-.284.25,0.365,0.365,0,0,0,.089.37l2.691,2.75-0.635,3.89a0.373,0.373,0,0,0,.14.36,0.32,0.32,0,0,0,.207.07,0.315,0.315,0,0,0,.163-0.04l3.327-1.84,3.327,1.84a0.355,0.355,0,0,0,.371-0.03,0.372,0.372,0,0,0,.139-0.36l-0.635-3.89,2.692-2.75A0.365,0.365,0,0,0,561.983,1176.56Z"
                                      transform="translate(-550 -1172)"
                                    ></path>
                                  </svg> */}
                                <i className="fa fa-play"></i>
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={
                              desc && news
                                ? "slide-content showed"
                                : desc && !news
                                ? "slide-content"
                                : "slide-content hidden"
                            }
                          >
                            <h2>
                              {truncate(item.title, Global.HEADCHAR)}
                              {Global.FAVOURITES ? (
                                <span
                                  className="span"
                                  onClick={(event) => {
                                    favourites(event, item, "video");
                                  }}
                                >
                                  {" "}
                                  <i
                                    className={
                                      favourited(
                                        item.mediaid,
                                        currentUser.FAVOURITES
                                      )
                                        ? "ri-check-fill"
                                        : "ri-add-line"
                                    }
                                  ></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </h2>
                            <div>
                              <span className="tag">{item.VIdeoDuration}</span>
                              <span className="tag">{item.PgRating}</span>
                            </div>
                            <p>
                              {truncate(item.ShortDescription, Global.PARACHAR)}
                            </p>
                          </div>
                        )}
                      </Link>
                    </div>
                  ))
              : ""}
          </div>
        </div>
      </div>
    );
  } else if (elemllstdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default LandscapeList;
